import * as React from "react";
import { Card, CardContent, Box } from "@mui/material";
import { Typography } from "@platform/design-system";

export type GaugeCardProps = {
  label: string;
  percentage: number; // 0–100
};

export const GaugeCard: React.FC<GaugeCardProps> = ({ label, percentage }) => {
  const clamped = Math.max(0, Math.min(100, percentage));
  const angle = (clamped / 100) * 180; // 0–180 deg

  const radius = 45;
  const centerX = 50;
  const centerY = 55;

  const pointerX = centerX + radius * Math.cos((Math.PI * (180 - angle)) / 180);
  const pointerY = centerY - radius * Math.sin((Math.PI * (180 - angle)) / 180);

  return (
    <Card
      elevation={1}
      sx={{
        borderRadius: 3,
        minHeight: 96,
        display: "flex",
        alignItems: "center",
        px: 2,
      }}
    >
      <CardContent
        sx={{
          width: "100%",
          "&:last-child": { pb: 2 },
          p: 1,
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ textTransform: "uppercase", mb: 0.5 }}
          color="textSecondary"
        >
          {label}
        </Typography>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mt: 0.5,
          }}
        >
          <Typography variant="header-small">
            <strong>{clamped}%</strong>
          </Typography>
          <Box sx={{ width: 96, height: 56 }}>
            <svg viewBox="0 0 100 60" width="100%" height="100%">
              {/* gauge arc */}
              <path
                d="M10 50 A40 40 0 0 1 90 50"
                fill="none"
                stroke="#E0E0E0"
                strokeWidth={6}
              />
              {/* colored arc under pointer */}
              <path
                d="M10 50 A40 40 0 0 1 90 50"
                fill="none"
                stroke="#5E6AD2"
                strokeWidth={6}
                strokeDasharray={`${(clamped / 100) * 126} 126`}
                strokeLinecap="round"
              />
              {/* center circle */}
              <circle cx={centerX} cy={centerY} r={3} fill="#5E6AD2" />
              {/* pointer */}
              <line
                x1={centerX}
                y1={centerY}
                x2={pointerX}
                y2={pointerY}
                stroke="#5E6AD2"
                strokeWidth={3}
                strokeLinecap="round"
              />
            </svg>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};
